import { fromEvent, Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

export class CardinalCspMonitor {
  private static readonly cspEventName = "securitypolicyviolation";

  monitor(domains: string[]): Observable<SecurityPolicyViolationEvent> {
    return fromEvent<SecurityPolicyViolationEvent>(
      document,
      CardinalCspMonitor.cspEventName,
    ).pipe(
      filter((event) => this.isSongbirdBlocked(event, domains)),
      map((event) => event),
    );
  }

  private isSongbirdBlocked(
    event: SecurityPolicyViolationEvent,
    domains: string[],
  ): boolean {
    const isRelevantDirective =
      event.violatedDirective === "script-src" ||
      event.violatedDirective === "connect-src" ||
      event.violatedDirective === "script-src-elem";

    const blockedUriLower = event.blockedURI.toLowerCase();
    const isSongbirdDomain = domains.some((domain) =>
      blockedUriLower.includes(domain.toLowerCase()),
    );

    return isRelevantDirective && isSongbirdDomain;
  }
}
